import type { DocumentResult, ExtractionField } from './serviceExecutionApi';

export const documentFieldTypes = { TEXT: 'Текст', NUMBER: 'Число', DATE: 'Дата', CATEGORY: 'Категория' };

export function documentFieldIssue(field: ExtractionField, value: string | null): string {
  if (value === null || !value.trim()) return field.required ? 'Обязательное поле не заполнено' : '';
  if (field.kind === 'NUMBER' && !/^[+-]?(?:[0-9]+(?:\.[0-9]+)?|\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/.test(value.trim())) return 'Нужно число с точкой, без разделителей тысяч; допустима научная запись, например 1.2e3';
  if (field.kind === 'DATE') {
    const date = new Date(`${value}T00:00:00.000Z`);
    if (!/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(value) || value.startsWith('0000') || Number.isNaN(date.getTime()) || date.toISOString().slice(0, 10) !== value) return 'Нужна действительная дата в формате ГГГГ-ММ-ДД';
  }
  if (field.kind === 'CATEGORY' && !field.categories?.includes(value)) return 'Выберите значение из вариантов этого поля';
  return '';
}

export function documentIssues(value: DocumentResult): { record: number; field: string; message: string }[] {
  return value.records.flatMap((record, index) => record.included ? value.config.fields.flatMap((field) => {
    const cell = record.cells.find((item) => item.field === field.name);
    const message = documentFieldIssue(field, record.corrections[field.name] ?? cell?.value ?? null);
    return message ? [{ record: index + 1, field: field.name, message }] : [];
  }) : []);
}
